<template>
    <div
        class="md caption"
        :class="[caption? 'is-true': '']"
    >
        <a :title="caption" v-html="caption"></a>
        <cpLabel
            v-if="minorCaption"
            themes="minor"
            :text="minorCaption"
        ></cpLabel>
        <slot></slot>
    </div>
</template>

<script>
    import cpLabel from '@/components/cpLabel'

    export default {
        components: {
            cpLabel,
        },
        props: {
            caption: {
                type: String,
                required: false,
                default: '標題'
            },
            minorCaption: {
                type: String,
                required: false,
                default: ''
            },
        }
    }
</script>

<style scoped lang="scss">

    %defaultCaption {

        a {
            font-size: $font-size-l;
            vertical-align: middle;
            color: $deep !important;
            font-weight: bold;
        }

        /*cp*/.label {
            vertical-align: middle;
            margin-left: $interval-s;
        }
    }

    .md.caption {

        .lo.extend & { //popup
            flex-shrink: 0;
            padding: $interval-l $interval-xxl $interval-m;
            color: $major-color;
            position: relative;

            // &.is-true {
            //     margin-bottom: $interval-m;

            //     &::before {
            //         content: $content;
            //         position: absolute;
            //         right: $interval-xxl;
            //         left: $interval-xxl;
            //         background-color: $major-color;
            //         height: 1px;
            //         bottom: 0;
            //     }
            // }

            a {
                display: block;
                font-size: $font-size-l;
                color: inherit;
            }


            /*cp*/.label {
                vertical-align: middle;
                margin-left: $interval-s;
            }
        }

        .lo.extend .pop-up-content & { //popup
            @extend %defaultCaption;
            margin-bottom: $interval-xs;
        }

        .lo.extend .pop-up-content * + & { //popup
            margin-top: $interval-l;
        }

        .lo.extend .g.tool-tip & { //tooltip
            padding: $interval-s;
            color: $major-color;

            a {
                color: inherit;
            }
        }

        .lo.heading & {
            flex: 1;

            a {
                display: $deep;
                font-size: $font-size-xl;
                color: $black;
                line-height: $btnInput_h; //配合 btn
            }

            .label {
                vertical-align: text-bottom;
                margin-left: $interval-s;
            }
        }

        .lo.article & {
            @extend %defaultCaption;

            + .md, + .g {
                margin-top: $interval-s;
            }
        }

        .lo.aside & {
            margin-bottom: $interval-m;
            padding-left: $interval-m;

            a {
                display: block;
                font-size: $font-size-l;
            }

            @include media('mobile') {
                padding-left: 0;
                color: $white;
            }
        }
    }
</style>
